import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import {
    openCampaignAndGroupSelector,
    openCampaignTypesMenu
} from '../../actions/campaignAndGroupSelector';
import {
    AddEntityMenu,
    AddEntityMenuProps
} from '../../components/AddEntityMenu/AddEntityMenu';
import { selectAddEntityItems } from '../../selectors/sidebar/sidebar';
import {
    CampaignAndGroupSelectorEntityToSelectType,
    State
} from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

export type StateProps = TStateProps<AddEntityMenuProps>;

export type DispatchProps = TDispatchProps<AddEntityMenuProps>;

const mapStateToProps = (state: State): StateProps => {
    const items = selectAddEntityItems(state);

    return {
        items
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return {
        openCampaignAndGroupSelector(
            type: CampaignAndGroupSelectorEntityToSelectType
        ) {
            dispatch(openCampaignAndGroupSelector(type));
        },
        openCampaignTypesMenu() {
            dispatch(openCampaignTypesMenu());
        }
    };
};

export const AddEntityMenuContainer = connect<StateProps, DispatchProps, {}>(
    mapStateToProps,
    mapDispatchToProps
)(AddEntityMenu);
